import { gql } from '@apollo/client';

export default gql`
  query warrantyCountsByState {
    warrantyCountsByState {
      pending
      labReview
      customerServiceReview
      orthodonticOfficeReview
      partnerSuccessReview
      reviewForProduction
      pendingRescanRequested
      rejected
      approved
    }
  }
`;
